import script from "./FloorPlan3D.vue?vue&type=script&setup=true&lang=js"
export * from "./FloorPlan3D.vue?vue&type=script&setup=true&lang=js"

import "./FloorPlan3D.vue?vue&type=style&index=0&id=014d8228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-014d8228"]])

export default __exports__